// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1XKXI","title":"Images90_title__1nAkY","images":"Images90_images__1PYr2"};